import _ from 'lodash';
//MUI
import PropTypes, { InferProps } from 'prop-types';
import { Box, Typography, MenuItem, Divider, ListItemIcon } from '@mui/material';
import { ProfileAvatar, AvatarMenu, MenuAvatar } from 'theme/layouts/navbar';
import Logout from '@mui/icons-material/Logout';
import { logoutUser } from 'services/auth.service';
//reducers
import { getUserDetails, setSelectedCompany } from 'state/reducers/user.reducers';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { Stack } from '@mui/system';
import { CenteredText } from 'theme/elements/Content';
import Done from '@mui/icons-material/Done';
import { useMsal } from '@azure/msal-react';
import { Company } from 'constants/company.constants';
import { getMobile } from 'state/reducers/ui.reducers';
import { useNavigate } from 'react-router-dom';
import { pagesEnum } from 'constants/ui.constants';
import { getCompanyLetter, getCompanyName } from 'utils';
import { useMemo } from 'react';
import { selectLanguage, selectTranslations, toggleLang } from 'state/reducers/translation.reducers';

Profile.propTypes = {
  handleClose: PropTypes.func.isRequired,
  companies: PropTypes.array,
};

export default function Profile({ handleClose, companies }: InferProps<typeof Profile.propTypes>) {
  const dispatch = useAppDispatch();
  const user = useAppSelector(getUserDetails);
  const { companyId } = useAppSelector(getUserDetails);
  const { instance, accounts } = useMsal();
  const isMobile = useAppSelector(getMobile);
  const navigate = useNavigate();
  const selectedLang = useAppSelector(selectLanguage);
  const t = useAppSelector(selectTranslations)
  const lang = useAppSelector(selectLanguage);

  const switchCompany = (selectedCompanyId: number) => {
    if (companyId !== selectedCompanyId) {
      dispatch(toggleLang(localStorage.getItem('language') || 'en'));
      dispatch(setSelectedCompany(selectedCompanyId));
      navigate(`/${pagesEnum.DASHBOARD}`);
      window.location.reload();
    }
    handleClose();
  };

  const companyName = useMemo(() => {
    if (companies) {
      const SelectedCompany = companies?.filter((company) => company.id === companyId)[0];
      return getCompanyName(SelectedCompany?.hebrewName, SelectedCompany?.englishName, selectedLang);
    }
  }, [companyId, companies]);

  return (
    <>
      <AvatarMenu>
        <CenteredText>
          <Box sx={{ displayDirection: isMobile ? 'row' : 'column' }}>
            <Stack
              direction={isMobile ? 'row' : 'column'}
              spacing={1}
              sx={{
                margin: isMobile ? '18px auto 12px 15px' : '18px auto 12px auto',
                flexDirection: isMobile ? 'row' : 'column',
                justifyContent: isMobile ? 'left' : 'center',
                alignItems: 'center',
              }}
            >
              <ProfileAvatar>
                {getCompanyLetter(user?.companyHebrewName, user?.companyName, selectedLang)}
              </ProfileAvatar>
              <Stack>
                <Typography variant="h5">{companyName}</Typography>
                <Typography variant="body3">{user?.companyAccountId}</Typography>
              </Stack>
            </Stack>
          </Box>
        </CenteredText>
        <Divider />
        <Stack>
          {companies &&
            companies.map((company: Company, index: number) => {
              return (
                <MenuItem
                  key={index}
                  className={companyId == company.id ? 'selected' : ''}
                  onClick={() => switchCompany(company.id!)}
                  sx={{ marginTop: '7px!important' }}
                >
                  {companyId == company.id ? (
                    <MenuAvatar className="selected">
                      <Done />
                    </MenuAvatar>
                  ) : (
                    <MenuAvatar />
                  )}
                  <Box>
                    <Typography>
                      {getCompanyName(company?.hebrewName, company?.englishName, selectedLang)}
                    </Typography>
                    <Typography variant="lightSmall">{company.accountId}</Typography>
                  </Box>
                </MenuItem>
              );
            })}
          <Divider />
          <MenuItem
            onClick={() => {
              handleClose();
              logoutUser(instance, accounts);
            }}
          >
            <ListItemIcon>
              <Logout fontSize="small" />
            </ListItemIcon>
            {lang === 'he' ? 'התנתק' : 'Logout'}
          </MenuItem>
        </Stack>
      </AvatarMenu>
    </>
  );
}
